import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { map } from 'rxjs/operators';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';


@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService {

  constructor(private http: HttpClient) { }


  public previewObserver = new Subject<any>()


  getEamilTemplate(companyId: any) {
    
    // /emailTemplate/company/${companyId}/list

    let payload = {"superTaskTypeId":"EMALTEMPLT","isDefault":"false","pageNumber":1,"pageSize":1000,"searchText":""};


    return this.http.post(`/emailTemplate/list/EMALTEMPLT?tempCategory='GENERIC'&tempCategory='LEAD'`, payload).pipe(
      map((response: ImagilityBaseResponse) => response.data));

  }

  getCreateTemplate(payload) {
    return this.http.post(`/emailTemplate/create`, payload).pipe(
      map((response: ImagilityBaseResponse) => response)
    );
  }

  getAIGeneratedValue(searchQuery) {
    return this.http.get(`/getAiLetterTemplate/${searchQuery}`).pipe(
      map((response: ImagilityBaseResponse) => response)
    );
  }

  deleteTemplate(id) {
    return this.http.delete(`/emailTemplate/delete/${id}`).pipe(
      map((data) => { return data; }));
  }

  previewTemplate(id) {
    // /emailTemplate/${id}/fetch
    
    return this.http.get(`/emailTemplates/emailTemplateId/${id}`).pipe(map((response: ImagilityBaseResponse) => response.data));

  }



}
